export default __webpack_public_path__ + "static/media/hr.ffb110bf.svg";